<template>
  <v-card flat class="pa-3 mt-2">
    <v-card-subtitle> Conteo </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-item-group v-model="tipo_conteo" mandatory>
                  <v-row>
                    <v-col>
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          height="70"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div class="white--text flex-grow-1 text-center">
                              Conteo Express <br />
                              <small>Conteo segun movimientos del dia</small>
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                    <v-col>
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center"
                          dark
                          height="70"
                          @click="toggle"
                        >
                          <v-scroll-y-transition>
                            <div class="white--text flex-grow-1 text-center">
                              Conteo General<br />
                              <small>Conteo general de productos</small>
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="datos.hora" outlined dense type="time" label="Hora Corte"></v-text-field>
                    <SelectAlmacen
                      :dense="true"
                      :outlined="true"
                      :add="false"
                      v-model="datos.id_almacen"
                      :filtro="{ id_puesto: store.state.puestoSelect.id_puesto, id_tipo_almacen: 1 }"
                      :rules="reglas.requerido"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      label="Observacion"
                      value=""
                      rows="4"
                      dense
                      outlined
                      :rules="reglas.requerido"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      :loading="cargarProductosConteoCargando"
                      v-if="tipo_conteo == 0"
                      @click="cargarProductosConteo()"
                      class="secondary"
                      :disabled="!datos.hora_corte && !datos.id_almacen"
                      >Buscar productos</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th width="10%" class="text-left">ID</th>
                        <th class="text-left">Producto</th>
                        <th width="30%" class="text-left">Cantidad</th>
                        <th width="10%" class="text-left text-center">Cantidad Real</th>
                        <th width="5%" class="text-left text-center"></th>
                        <th v-if="false" width="10%" class="text-left text-center">Final</th>
                        <th v-if="false" width="10%" class="text-left text-center">Diferencia</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in datos.productos.filter(it => !it.omitir)"
                        :key="index"
                        :class="focusSelect == 'fieldId_' + index ? 'grey2' : ''"
                      >
                        <td>{{ item.id_producto }}</td>
                        <td>
                          {{ item.nombre }}
                          <br />
                          <small class="info--text">{{ !item.ind_peso_conteo ? '' : 'Calculado en peso' }} </small>
                        </td>
                        <td>
                           
                            <v-text-field
                              :prepend-icon="
                                item.conteo_peso_total > 0
                                  ? !item.ind_peso_conteo
                                    ? icons.mdiCheckboxBlankOutline
                                    : icons.mdiCheckboxMarked
                                  : ''
                              "
                              :id="'fieldId_' + index"
                              :ref="'fieldId_' + index"
                              v-on:keyup="enterInput"
                              dense
                              outlined
                              hide-details="auto"
                              :suffix="item.ind_peso_conteo ? 'g' : item.unidad"
                              v-model="item.conteo"
                              @click:prepend="item.ind_peso_conteo = !item.ind_peso_conteo"
                              @focus="focusSelect = 'fieldId_' + index"
                              :autofocus="index == 0"
                              type="number"
                              :rules="reglas.requerido_mayor_cero" 
                            ></v-text-field> 
                            <small v-if="item.ind_peso_conteo" ><strong>Peso Total: </strong>{{ item.conteo_peso_total }} g</small>
                            <small v-if="item.ind_peso_conteo"> / <strong>Peso Vacio:</strong>  {{ item.conteo_peso_vacio }} g</small>
                            <small v-if="item.ind_peso_conteo"> / <strong>Total Unidades:</strong>  {{ item.conteo_unidades_totales }} {{ item.unidad }}</small>                           
                        </td>
                        <td class="text-center">
                          {{
                            !item.ind_peso_conteo
                              ? Number(item.conteo).toFixed(2)
                              : funciones.truncarDecimal(
                                  (item.conteo_unidades_totales / (item.conteo_peso_total - item.conteo_peso_vacio)) *
                                  (item.conteo - item.conteo_peso_vacio)
                                )
                          }}
                          {{ item.unidad }}
                        </td>
                        <td class="text-center"><v-btn x-small @click="item.omitir = true">omitir</v-btn></td>
                        <td v-if="false" class="text-center">
                          {{ item.final }}
                        </td>
                        <td v-if="false" class="text-center">
                          {{
                            Number(
                              !item.ind_peso_conteo
                                ? Number(item.conteo).toFixed(2)
                                : (
                                    (item.conteo_unidades_totales / (item.conteo_peso_total - item.conteo_peso_vacio)) *
                                    (item.conteo - item.conteo_peso_vacio)
                                  ).toFixed(0),
                            ) - item.final
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <div class="text-right">
              <v-btn color="secondary" class="me-3" @click="mostratOmitidos()" v-if="omitidos()" small>
                Mostrar Omitidos
              </v-btn>
              <v-btn color="secondary" class="me-3" @click="limpiar()" small> Limpiar </v-btn>
              <v-btn color="primary" class="me-3" small @click="Guardar()"> Finalizar </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
  <script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import store from '@/store'
import goTo from 'vuetify/lib/services/goto'
import DatePicker from '@/components/DatePicker.vue'
import BuscarProducto from '@/views/sistema/inventario/producto/componentes/BuscarProductoExistencia.vue'
import SelectEstado from '@/views/sistema/administracion/archivo/estado/componentes/Select.vue'
import funciones from '@/funciones/funciones'
import TooltipInfo from '@/components/TooltipInfo.vue'
import { mdiInformation, mdiDelete, mdiPencil, mdiCheckboxBlankOutline, mdiCheckboxMarked } from '@mdi/js'
import FabricacionServices from '@/api/servicios/inventario/FabricacionServices'
import SelectAlmacen from '@/views/sistema/inventario/maestro/almacen/componentes/Select.vue'

import moment from 'moment'
import AjusteServices from '@/api/servicios/inventario/AjusteServices'
export default {
  components: { SelectAlmacen },
  watch: {
    '$store.state.puestoSelect.id_puesto': function () {
      this.limpiar()
    },
  },

  methods: {
    enterInput(valor) {
      const inputSplit = valor.target.id.split('_')
      if (valor.key == 'Enter' || valor.key == 'ArrowDown') {
        const inputNewId = inputSplit[0] + '_' + (Number(inputSplit[1]) + 1)
        const inputNew = this.$refs[inputNewId]

        if (inputNew) {
          console.log(inputNew[0])
          inputNew[0].focus()
        }
      } else if (valor.key == 'ArrowUp') {
        const inputNewId = inputSplit[0] + '_' + (Number(inputSplit[1]) - 1)
        const inputNew = this.$refs[inputNewId]

        if (inputNew) {
          inputNew[0].focus()
        }
      }
    },
  },
  setup(props, context) {
    const focusSelect = ref(null)
    const tipo_conteo = ref(0)
    const guardando = ref(false)
    watch(tipo_conteo, () => {
      limpiar()
    })
    const reglas = {
      requerido: [v => !!v || 'Es requerido'],
      requerido_mayor_cero: [v => !!v && v>=0 || 'Debe ser mayo  iguala 0'],
    }
    const datosInit = {
      id: -1,
      fecha: moment().format('DD-MM-YYYY'),
      hora: moment().format('HH:mm:00'),
      productos: [],
      id_almacen: null,
    }
    const datos = ref(JSON.parse(JSON.stringify(datosInit)))
    const cargarProductosConteoCargando = ref(false)
    const cargarProductosConteo = () => {
      datos.value.productos = []
      cargarProductosConteoCargando.value = true
      AjusteServices.consultarConteoExpress({
        id_puesto: store.state.puestoSelect.id_puesto,
        hora_corte: datos.value.hora,
        id_almacen: datos.value.id_almacen,
      })
        .then(response => {
          if (response.data && response.data.length > 0) {
            datos.value.productos = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          cargarProductosConteoCargando.value = false
        })
    }

    const omitidos = () => {
      const xx = datos.value.productos.filter(item => item.omitir == true)

      return xx.length > 0
    }

    const mostratOmitidos = () => {
      datos.value.productos.forEach(item => (item.omitir = false))
    }

    const limpiar = () => {
      datos.value = JSON.parse(JSON.stringify(datosInit))
    }
    const validarForm = () => {
      let val = form.value?.validate()

      return val
    }
    const Guardar = () => {
      guardando.value = true
      if (validarForm()) {
        try {
          AjusteServices.conteoActualizar({ ...datos.value, id_puesto: store.state.puestoSelect.id_puesto, id_empleado: store.state.user.id_empleado })
            .then(response => {
              console.log(response)
              if (response.data.mensaje == 'GUARDADO CON EXITO') {
                store.commit('setAlert', {
                  message: response.data.mensaje,
                  type: 'success',
                })
                ActualizarLista(response.data.datos)
                limpiar()
              } else {
                store.commit('setAlert', {
                  message: `${response.data.mensaje}`,
                  type: 'warning',
                })
              }
            })
            .catch(error => {
              console.log(error)
              store.commit('setAlert', {
                message: error,
                type: 'error',
              })
            })
            .finally(() => {
              guardando.value = false
            })
        } catch (error) {
          store.commit('setAlert', {
            message: error,
            type: 'error',
          })
        }
      } else {
        store.commit('setAlert', {
          message: 'Verifique que todos los datos estén completos',
          type: 'warning',
        })
      }
    }

    const form = ref(null)
    return {
      limpiar,
      datos,
      cargarProductosConteo,
      cargarProductosConteoCargando,
      tipo_conteo,
      mostratOmitidos,
      omitidos,
      focusSelect,
      icons: {
        mdiCheckboxBlankOutline,
        mdiCheckboxMarked,
      },
      moment,
      store,
      reglas,
      form,
      Guardar,
      funciones
    }
  },
}
</script>